
import { useState, useEffect } from 'react';
import { useAccount } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { checkTokenOwnership } from '@/lib/web3Utils';
import { toast } from "sonner";

export const useTokenCheck = (alreadyInitialized: boolean) => {
  const { address, isConnected, chainId } = useAccount();
  const [hasToken, setHasToken] = useState<boolean>(false);
  const [isCheckingToken, setIsCheckingToken] = useState<boolean>(false);
  
  // Check if connected to BSC
  const isConnectedToBSC = chainId === bsc.id;

  // Check token ownership when wallet connected
  useEffect(() => {
    const checkTokens = async () => {
      if (isConnected && address && isConnectedToBSC && !alreadyInitialized) {
        setIsCheckingToken(true);
        
        try {
          console.log("Checking wallet for $TOP1:", address);
          console.log("Chain ID:", chainId);
          const ownsTokens = await checkTokenOwnership(address);
          console.log("$TOP1 token ownership result:", ownsTokens);
          setHasToken(ownsTokens);
        } catch (error) {
          console.error("Error checking $TOP1 token balance:", error);
          toast.error("Error checking your $TOP1 balance");
        }
        
        setIsCheckingToken(false);
      }
    };
    
    checkTokens();
  }, [isConnected, address, isConnectedToBSC, chainId, alreadyInitialized]);

  const handleRecheckWallet = async () => {
    if (isConnected && address) {
      setIsCheckingToken(true);
      
      try {
        console.log("Rechecking wallet for $TOP1:", address);
        const ownsTokens = await checkTokenOwnership(address);
        console.log("$TOP1 token ownership recheck result:", ownsTokens);
        setHasToken(ownsTokens);
        
        if (ownsTokens) {
          toast.success("$TOP1 tokens detected! You're good to go.");
        } else {
          toast.error("No $TOP1 tokens found yet. Try again in a minute.");
        }
      } catch (error) {
        console.error("Error checking $TOP1 token balance:", error);
        toast.error("Error checking your $TOP1 balance");
      }
      
      setIsCheckingToken(false);
    }
  };

  return { hasToken, isCheckingToken, isConnectedToBSC, handleRecheckWallet };
};
